export default () => ({
  top: 0,
  size: 0,
  height: 0,
  open: false,

  scroll(e) {
    this.top =
      document.documentElement.scrollTop < 37
        ? document.documentElement.scrollTop
        : 36;

    this.size =
      document.documentElement.scrollTop < 100
        ? document.documentElement.scrollTop
        : 100;
  },

  init() {},
});
